// extracted by mini-css-extract-plugin
export var button = "_5v-4";
export var hasDarkBackground = "_5v-7";
export var hasLightBackground = "_5v-6";
export var iconWrapper = "_5v-0";
export var large = "_5v-2";
export var medium = "_5v-1";
export var small = "_5v-5";
export var xsmall = "_5v-3";